import { createSelector } from 'reselect'

const contacts = (orgContacts, collection) => ({
  orgContacts,
  collection
})

// collection - data from API
// orgContacts - dropdown items
const mapForDropdown = ({ orgContacts, collection }) => {
  // Works for Coordinators:
  if (collection instanceof Array) {
    if (collection.length === 0) {
      return orgContacts
    }

    // Show only dropdown options that are not used
    return orgContacts.filter(contact => {
      const rawContact =
        collection.find(coord => contact.value === coord.id) || {}

      return !rawContact.isCoordinator
    })
  }

  if (!collection) {
    return orgContacts
  }

  // Works For Authorizing Contact:
  return orgContacts.filter(contact => contact.value !== collection.id)
}

export default createSelector(contacts, mapForDropdown)
